import request from "@/utils/request";

//我的写手- 列表
export function writer_tabulation(data) {
  return request({
    url: "/data/writer/writer_tabulation",
    method: "post",
    data
  });
}

//我的写手- 录入写手信息
export function add_writer(data) {
  return request({
    url: "/data/writer/add_writer",
    method: "post",
    data
  });
}

//我的写手- 编辑写手信息
export function edit_writer(data) {
  return request({
    url: "/data/writer/edit_writer",
    method: "post",
    data
  });
}

//我的写手- 标签列表
export function label_tabulation(data) {
  return request({
    url: "/data/writer/label_tabulation",
    method: "post",
    data
  });
}

//我的写手- 添加标签
export function add_label(data) {
  return request({
    url: "/data/writer/add_label",
    method: "post",
    data
  });
}

//我的写手- 添加批注
export function add_connectionremark(data) {
  return request({
    url: "/data/writer/add_connectionremark",
    method: "post",
    data
  });
}

//我的写手- 初始压稿申请
export function initial_press_release_apply(data) {
  return request({
    url: "/data/writer/initial_press_release_apply",
    method: "post",
    data
  });
}

//我的写手- 骗子库
export function pz_writer_tabulation(data) {
  return request({
    url: "/data/writer/pz_writer_tabulation",
    method: "post",
    data
  });
}

//初始压稿 - 列表
export function initial_press_release_list(data) {
  return request({
    url: "/data/writer/initial_press_release_list",
    method: "post",
    data
  });
}

//初始压稿 - 申请
export function initial_apply(data) {
  return request({
    url: "/data/writer/initial_apply",
    method: "post",
    data
  });
}

//初始压稿 - 申请记录
export function press_application(data) {
  return request({
    url: "/data/writer/press_application",
    method: "post",
    data
  });
}

//接单中心 - 列表
export function order_taking_list(data) {
  return request({
    url: "/data/writer/order_taking_list",
    method: "post",
    data
  });
}

//接单中心 - 提取文件
export function draw_file(data) {
  return request({
    url: "/data/writer/draw_file",
    method: "post",
    data
  });
}

//接单中心 - 上传文件
export function upload_file(data) {
  return request({
    url: "/data/writer/upload_file",
    method: "post",
    data
  });
}

//接单中心 - 确定写手
export function define_writer(data) {
  return request({
    url: "/data/writer/define_writer",
    method: "post",
    data
  });
}

//写手书籍信息 - 登记列表
export function connectionessay_list(data) {
  return request({
    url: "/data/writer/connectionessay_list",
    method: "post",
    data
  });
}

//写手书籍信息 - 编辑书籍信息
export function edit_connectionessay(data) {
  return request({
    url: "/data/writer/edit_connectionessay",
    method: "post",
    data
  });
}

//写手书籍信息 - 停止合作
export function cease_cooperate(data) {
  return request({
    url: "/data/writer/cease_cooperate",
    method: "post",
    data
  });
}

//写手书籍信息 - 转周结
export function write_operate(data) {
  return request({
    url: "/data/writer/write_operate",
    method: "post",
    data
  });
}

//写手书籍信息 - 上传文件
export function file_operate(data) {
  return request({
    url: "/data/uploadfile/file_operate",
    method: "post",
    data
  });
}

//写手公海信息 - 列表
export function writer_list(data) {
  return request({
    url: "/data/internationalwaters/writer_list",
    method: "post",
    data
  });
}

//写手公海信息 - 转入我的写手
export function change_writer(data) {
  return request({
    url: "/data/internationalwaters/change_writer",
    method: "post",
    data
  });
}

//写手公海信息 - 历史备注
export function writer_connectionremark_list(data) {
  return request({
    url: "/data/internationalwaters/writer_connectionremark_list",
    method: "post",
    data
  });
}

// 每日上传稿件 - 查重结果列表
export function connectionrecord_list(data) {
  return request({
    url: "/data/uploadfile/connectionrecord_list",
    method: "post",
    data
  });
}

// 每日上传稿件 - 压稿
export function deposit_operate(data) {
  return request({
    url: "/data/uploadfile/deposit_operate",
    method: "post",
    data
  });
}

// 每日上传稿件 - 差价
export function manuscript_operate(data) {
  return request({
    url: "/data/uploadfile/manuscript_operate",
    method: "post",
    data
  });
}

// 每日上传稿件 - 上传附件
export function connectionrecord_zip(data) {
  return request({
    url: "/data/uploadfile/connectionrecord_zip",
    method: "post",
    data
  });
}

// 每日上传稿件 - 上传单个文件
export function word_operate(data) {
  return request({
    url: "/data/uploadfile/word_operate",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 列表
export function fee_manage_list(data) {
  return request({
    url: "/data/writer/fee_manage_list",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 预支稿费下拉列表
export function advancefee_list(data) {
  return request({
    url: "/data/writer/advancefee_list",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 预支稿费
export function advancefee_subscribe(data) {
  return request({
    url: "/data/writer/advancefee_subscribe",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 暂压稿下拉列表
export function depositprocess_list(data) {
  return request({
    url: "/data/writer/depositprocess_list",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 暂压稿
export function depositprocess_subscribe(data) {
  return request({
    url: "/data/writer/depositprocess_subscribe",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 确认完结
export function depositprocess_js_wc(data) {
  return request({
    url: "/data/writer/depositprocess_js_wc",
    method: "post",
    data
  });
}

// 稿费预支及压稿 - 申请结算
export function sq_depositprocess(data) {
  return request({
    url: "/data/writer/sq_depositprocess",
    method: "post",
    data
  });
}

// 稿费预支申请记录
export function advancefee_apply(data) {
  return request({
    url: "/data/writer/advancefee_apply",
    method: "post",
    data
  });
}

// 暂压稿费申请记录
export function depositprocess_subscribe_apply(data) {
  return request({
    url: "/data/writer/depositprocess_subscribe_apply",
    method: "post",
    data
  });
}

// 暂压稿费申请记录 --结算
export function depositprocess_js(data) {
  return request({
    url: "/data/writer/depositprocess_js",
    method: "post",
    data
  });
}

// 压稿管理 --列表
export function deposit_list(data) {
  return request({
    url: "/data/writer/deposit_list",
    method: "post",
    data
  });
}

// 压稿管理 --结算
export function deposit_js(data) {
  return request({
    url: "/data/writer/deposit_js",
    method: "post",
    data
  });
}

// 压稿管理 --查看详情
export function deposit_details(data) {
  return request({
    url: "/data/writer/deposit_details",
    method: "post",
    data
  });
}

// 书籍上传文件 - 书籍列表
export function connectionessay_file_list(data) {
  return request({
    url: "/data/writer/connectionessay_file_list",
    method: "post",
    data
  });
}

// 书籍上传文件 - 压缩包上传
export function connectionessay_file_up(data) {
  return request({
    url: "/data/writer/connectionessay_file_up",
    method: "post",
    data
  });
}

// 上传周稿 -压缩包
export function week_zip(data) {
  return request({
    url: "/data/uploadfile/week_zip",
    method: "post",
    data
  });
}

// 上传周稿 -单个文件
export function week_word(data) {
  return request({
    url: "/data/uploadfile/week_word",
    method: "post",
    data
  });
}

// 上传周稿 -列表
export function week_list(data) {
  return request({
    url: "/data/uploadfile/week_list",
    method: "post",
    data
  });
}

// 数据中心 - 我的考核 - 列表
export function examine_list(data) {
  return request({
    url: "/data/writerdatacenter/examine_list",
    method: "post",
    data
  });
}

// 数据中心 - 我的考核 - 上传截图
export function upload_connectpoints(data) {
  return request({
    url: "/data/writerdatacenter/upload_connectpoints",
    method: "post",
    data
  });
}

// 数据中心 - 我的数据 - 列表
export function information_list(data) {
  return request({
    url: "/data/writerdatacenter/information_list",
    method: "post",
    data
  });
}

// 写手日结登记  - 列表
export function connectionrecord_day_list(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_day_list",
    method: "post",
    data
  });
}

// 写手日结登记  - 驳回
export function connectionrecord_day_suggestions(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_day_suggestions",
    method: "post",
    data
  });
}

// 写手日结登记  - 修改备注
export function connectionrecord_w_qd_remark(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_w_qd_remark",
    method: "post",
    data
  });
}

// 写手日结表  - 列表
export function connectionrecord_history_list_week(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_history_list_week",
    method: "post",
    data
  });
}

// 写手日结表  - 详情列表
export function connectionrecord_history_list(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_history_list",
    method: "post",
    data
  });
}

// 写手周结登记  - 列表
export function connectionrecord_week_list(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_week_list",
    method: "post",
    data
  });
}

// 写手周结登记  - 驳回
export function connectionrecord_week_suggestions(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_week_suggestions",
    method: "post",
    data
  });
}

// 写手周结登记  - 提交修改
export function reject_file_operate(data) {
  return request({
    url: "/data/uploadfile/reject_file_operate",
    method: "post",
    data
  });
}

// 写手周结表  - 列表
export function connectionrecord_history_week_list_week(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_history_week_list_week",
    method: "post",
    data
  });
}

// 写手周结表  - 详情列表
export function connectionrecord_history_week_list(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_history_week_list",
    method: "post",
    data
  });
}

// 写手周结表  - 导出
export function connectionrecord_history_week_list_week_excel(data) {
  return request({
    url: "/data/writerdatacenter/connectionrecord_history_week_list_week_excel",
    // responseType: "blob",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/utils/writer.js